import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import { Audience, checkMemberRunTask, checkMemberTask } from "../audience-api";
import { Modal } from "../components/Modal";
import { BotStore } from "../Store";
import { Bot, loadStatus } from "../bot-loaders";
import { sleep } from "simple-utils";
import { ProgressBar } from "../components/ProgressBar";
import { LoadingButton } from "../components/SavingButton";
import { TaskStatus as Status } from "../audience-api";
import { formatDuration, useETA } from "../hooks/eta-hook";


function useOnlineBot():Bot{
    const {state: {bots}} = useContext(BotStore);
    if(!bots) return null;
    return bots.find(b => b.status == 'online');
}

type State =  "initial" | "default" | "running"


type StateCompentProps = {audience:Audience, setState: (s:State)=>void, setError?: (e:string)=>void}

export function Loading({audience, setState, setBaseStatus}:StateCompentProps &{setBaseStatus?:(baseStatus:Status) => void}){
    const bot = useOnlineBot();
    useEffect(function(){
         (async() => {
            var status = await checkMemberTask(bot, audience.id);
            if(!status || status.complete)
                setState("default")
            else {
                setBaseStatus(status)
                setState("running")
            }
        })();
    }, [])

    return <>Loading...</>
}

export function RunningTaskUI({audience, setState, baseStatus, onChange}:StateCompentProps & {baseStatus:Status, onChange: ()=>void}){
    const bot = useOnlineBot();
    const [status, setStatus] = useState<Status>(baseStatus)

    useEffect(function(){
        async function check(){
           var status = await checkMemberTask(bot, audience.id);
           if(!status)
                return setState("default");

           if(status.done != baseStatus?.done)
                onChange();

           setStatus(status);
           if(!status.complete)
               d = setTimeout(check, 1000)
        };

        check();

        var d = setTimeout(check, 1000)

        return () => clearTimeout(d);
    }, [])

    const {estimatedTime} = useETA({currentItem: status.done + status.error, totalItems: status.total})

    return  <> 
        <p>Status {status.done + status.error} de {status.total} {status.complete && <i className="ms-2 fa fa-check text-success zoom-appear"></i>} <br />
        Corretos: {status.done}<br />
        Erros: {status.error}</p>

        { !status.complete && <p>
            Previsão de término: <b>{formatDuration(estimatedTime / 1000)}</b>
        </p> }

        <ProgressBar done={status.done + status.error} total={status.total} />
    </>
}

export function StartTaskUI({audience, setState, setError}:StateCompentProps){
    const bot = useOnlineBot();
    const [loading, setLoading] = useState(false);

    async function onClick(){
        if(loading) return;
        setLoading(true);
        try {
            await checkMemberRunTask(bot, audience.id);
            setState("running");
        }catch(e){
            console.log(e);
            setError(typeof e == 'string' ? e : "Erro desconhecido")
        }
        setLoading(false);

        
    }
    

    return  <> 
        <p>Clique no botão a seguir para checar se os contatos tem um número do Whatsapp</p>
        <LoadingButton icon="fa-check" saving={loading} onClick={onClick}>Checkar telefones do público</LoadingButton>
    </>
}

export function ValidateContactModal({audience, onChange}:{audience:Audience, onChange:()=>void}){
    const bot = useOnlineBot();
    const [state, setState] = useState<State>("initial")
    const [error, setError] = useState<string>(null)
    const [baseStatus, setBaseStatus] = useState<Status>({total: audience.members.length, done: 0, error: 0})

    if(!bot)
        return <>É necessário ter pelo menos um bot online.</>

    if(error)
        return <p><b className="me-2">Erro:</b> {error}</p>

    if(state == "initial")
        return <Loading audience={audience} setState={setState} setBaseStatus={setBaseStatus} setError={setError} />

    if(state == "default")
        return <StartTaskUI audience={audience} setState={setState} setError={setError} />

    return <RunningTaskUI audience={audience} setState={setState} onChange={onChange} baseStatus={baseStatus} setError={setError} />;
}



export function ValidateContactButton({audience, shouldUpdate}:{audience:Audience, shouldUpdate:()=>void}){
    const [show, setShow] = useState(false)
    const change = useRef<boolean>(false)

    const onHide = useCallback(() => {
        setShow(false)
        if(change.current)
            shouldUpdate();
        change.current = false
    }, [change])

    return  <>
        <button className="btn btn-info" onClick={() => setShow(true)}><i className="fa fa-user-check me-2"></i> Validar Contatos</button>
        {show && <Modal title="Validando Contatos" onHide={onHide}><ValidateContactModal audience={audience} onChange={() => change.current =true} /></Modal>}
    </>

}

/*function DeleteMembersButton(){
    const audience = useAudience();
    const confirm = useConfirm("Deseja realmente remover todos os contatos?", {title:audience.name, buttonClass:"btn-danger", ok:"Remover Contatos"});
    const {dispatch}  = useContext(AudienceContext);
    const addToast = useAddToast();

    async function doDelete(){
        const ok = await confirm();
        if(!ok) return;
        await deleteMembers(audience.id);
        addToast(`Contatos removidos!`, 'bg-success');
        dispatch({type: "setAudience", payload: {...audience, members: []}})
    }

    return <button className="btn btn-danger ms-2" onClick={doDelete}>Deletar Contatos</button>
}*/